import { render, staticRenderFns } from "./ModelSelect.vue?vue&type=template&id=f1b37756"
import script from "./ModelSelect.vue?vue&type=script&lang=js"
export * from "./ModelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports